interface KeychainMutePanelProps {
  username: string;
  onUsernameChange: (username: string) => void;
  keychainAvailable: boolean;
  statusMessage: string | null;
}

export function KeychainMutePanel({
  username,
  onUsernameChange,
  keychainAvailable,
  statusMessage,
}: KeychainMutePanelProps) {
  return (
    <div className="bg-white rounded-lg shadow-md border border-slate-200 p-4 mb-6">
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-64 flex-1">
          <label
            htmlFor="keychain-username"
            className="block text-xs font-semibold text-slate-700 mb-1"
          >
            Hive Keychain Username (for mute actions)
          </label>
          <input
            id="keychain-username"
            type="text"
            value={username}
            onChange={(e) => onUsernameChange(e.target.value)}
            placeholder="your-hive-username"
            className="w-full px-3 py-2 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-red-200 focus:border-hive"
          />
        </div>
        <div className="text-xs text-slate-600">
          {keychainAvailable ? 'Keychain detected' : 'Hive Keychain not detected'}
        </div>
      </div>
      <p className="mt-2 text-xs text-slate-600">
        Username is required before running analysis so muted accounts can be detected.
      </p>
      {statusMessage && <p className="mt-2 text-xs text-slate-600">{statusMessage}</p>}
    </div>
  );
}
